import React from "react";
import { Button, Typography } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./TeacherEvalDashboard.module.scss";

const { Text } = Typography;

// Fila de chips de seleccion de clase (envuelve a varias lineas si el profesor
// tiene muchas clases). Va debajo de la cabecera, encima de KPIs/cards.
export function ClassChips({ classes, selected, onSelect }) {
  const { t } = useTranslation("evaluations");
  if (!classes || classes.length === 0) {
    return (
      <div className={styles.classRow}>
        <Text type="secondary">{t("dashboard.noClasses")}</Text>
      </div>
    );
  }
  return (
    <div className={styles.classRow}>
      <span className={styles.classLabel}>{t("dashboard.classLabel")}</span>
      {classes.map((cls) => (
        <Button
          key={cls}
          size="small"
          className={`${styles.chip} ${
            cls === selected ? styles.chipActive : ""
          }`}
          onClick={() => onSelect(cls)}
        >
          {cls}
        </Button>
      ))}
    </div>
  );
}
